module.exports = __webpack_public_path__ + "img/pdf.5ea25114.svg";